export * from './dealer-doc-type-detail';

